import styled, { ISpacing } from 'styled-components';
import React from 'react';
import { JustifyContent } from 'ui-toolkit/theming/types/JustifyContent';

export interface IGridProps extends React.HTMLProps<HTMLDivElement> {
  columnCount?: number;
  width?: string;
  justifyItems?: JustifyContent;
  textAlign?: 'right' | 'left' | 'center';
  alignItems?: 'start' | 'end' | 'center' | 'stretch';
  columnWidth?: string;
  templateColumns?: string;
  columnGap?: keyof ISpacing;
  rowGap?: keyof ISpacing;
}

const getGridTemplate = (props: IGridProps): string =>
  props.templateColumns || `repeat(${props.columnCount || 1}, ${props.columnWidth || '1fr'})`;

export const Grid = styled.div<IGridProps>`
  display: grid;
  text-align: ${(props) => `${props.textAlign || 'left'}`};
  align-items: ${(props) => `${props.alignItems || 'start'}`};
  grid-template-columns: ${(props) => getGridTemplate(props)};
  row-gap: ${(props) => (props.rowGap ? props.theme.spacing[props.rowGap] : props.theme.spacing.spacing5)};
  column-gap: ${(props) => (props.columnGap ? props.theme.spacing[props.columnGap] : props.theme.spacing.spacing5)};
  white-space: ${(props) => (props.columnWidth === 'min-content' ? 'nowrap' : 'normal')};
  ${(props) => (props.justifyItems ? `justify-items:${props.justifyItems};` : '')}
  ${(props) => (props.width ? `width:${props.width};` : '')}
`;

export interface IGridItemProps {
  area?: string;
  columnStart?: string | number;
  columnEnd?: string | number;
  justifySelf?: JustifyContent;
  alignSelf?: 'start' | 'end' | 'center';
}

export const GridItem = styled.div<IGridItemProps>`
  ${({ area }) => area && `grid-area:${area}`}
  ${({ columnStart, columnEnd }) =>
    columnStart === undefined && columnEnd !== undefined ? `grid-column-end:${columnEnd};` : ''}
  ${({ columnStart, columnEnd }) =>
    columnEnd === undefined && columnStart !== undefined ? `grid-column-start:${columnStart};` : ''}
  ${({ columnStart, columnEnd }) =>
    columnStart !== undefined && columnEnd !== undefined ? `grid-column: ${columnStart} / ${columnEnd};` : ''}
  ${(props) => (props.justifySelf ? `justify-self:${props.justifySelf};` : '')}
  align-self: ${(props) => `${props.alignSelf || 'start'}`};
`;
